import {
  usePauseWorkflow,
  useReRunWorkflow,
  useUpdateWorkflow,
} from "@features/ux/components/workflow/hooks";
import { Button } from "@shared/ui/button";
import { Pause, SquarePenIcon, Power, PlayCircle } from "lucide-react";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const QuickAction = () => {
  const { id, name, status } = useParams(); // Get id, name, and status from params
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(true); // Track workflow active/inactive state
  const reRunWorkflow = useReRunWorkflow();
  const pauseWorkflow = usePauseWorkflow();
  const { mutateAsync: updateWorkflow, isPending: isUpdating } =
    useUpdateWorkflow(id);

  const handlePauseWorkflow = () => {
    const payloadPause = {
      id: id,
    };
    pauseWorkflow.mutateAsync(payloadPause);
  };

  const handleEditWorkflow = () => {
    navigate(`/communication-hub/workflows/edit/${id}`);
    // Add your navigation or modal logic here to open edit form
  };

  const handleToggleActiveStatus = async () => {
    const newStatus = !isActive;

    const payload = {
      status: newStatus ? "active" : "inactive",
      is_active: newStatus,
    };

    try {
      await updateWorkflow(payload);
      setIsActive(newStatus); // Update state after successful API call
      console.log(`Workflow ${id} ${newStatus ? "activated" : "deactivated"}`);
    } catch (error) {
      console.error("Error updating workflow status:", error);
    }
  };

  const handleRerunWorkflow = () => {
    const payload = {
      id: id,
    };

    reRunWorkflow.mutateAsync(payload);
    // Add your API call here to re-run the workflow
  };

  // Check if workflow has completed status (you'll need to pass this from params or props)
  const isCompleted = status === "completed";

  return (
    <div>
      <div>
        <h2 className="text-md font-semibold">Quick Actions</h2>
      </div>
      <div className="flex flex-col gap-2 mt-4">
        <Button variant="default" onClick={handlePauseWorkflow}>
          <Pause className="mr-2 h-4 w-4" /> Pause Workflow
        </Button>
        <Button variant="outline" onClick={handleEditWorkflow}>
          <SquarePenIcon className="mr-2 h-4 w-4" /> Edit Workflow
        </Button>
        <Button variant="outline" onClick={handleToggleActiveStatus}>
          <Power className="mr-2 h-4 w-4" />
          {isActive ? "Deactivate" : "Activate"} Workflow
        </Button>
        {/* {isCompleted && ( */}
        <Button variant="outline" onClick={handleRerunWorkflow}>
          <PlayCircle className="mr-2 h-4 w-4" /> Re-run Workflow
        </Button>
        {/* )} */}
      </div>
    </div>
  );
};

export default QuickAction;
